import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import * as _ from 'lodash';

import { english } from 'assets/locale/en';

@Injectable()
export class DictionaryService {
  public languages: Array<any> = [];
  public items: Array<any> = [];
  public selectedLanguage: any;

  constructor() {
    this.languages.push(english);
    if (localStorage.getItem('lang') === null) {
      localStorage.setItem('lang', english.langKey);
    }
    this.selectedLanguage = this.getLanguage();
    this.items = this.selectedLanguage.items;
  }

  get(key, extraParam: any = '') {
    if (key !== '') {
      if (this.items[key] !== undefined) {
        if (extraParam == '') {
          return this.items[key];
        } else {
          return this.items[key](extraParam);
        }
      } else {
        if (!environment.production) {
          console.log("Couldn't find '" + key + "' in language '" + localStorage.getItem('lang') + "'");
        }
        if (extraParam == '') {
          return key;
        } else {
          return key(extraParam);
        }
      }
    }
  }

  getLanguage() {
    return _.find(this.languages, { langKey: localStorage.getItem('lang') });
  }

  getCurrency(id: number) {
    let currency = '';

    switch (id) {
      case 1:
        currency = '$';
        break;

      default:
        currency = '$';
    }
    return currency;
  }

  getCurrencyId(currency: string) {
    let id: number;
    switch (currency) {
      case '$':
        id = 1;
        break;

      default:
        id = 1;
    }
    return id;
  }

  setLanguage(lang) {
    localStorage.setItem('lang', lang.langKey);
    location.reload();
  }
}
